const socials = [
    {
        id: 1,
        icon: '9.png',
        url: 'https://twitter.com/leverageerc'
    },
    {
        id: 2,
        icon: '8.png',
        url: 'https://t.me/leverageprotocol'
    },
    {
        id: 3,
        icon: '10.png',
        url: '#'
    },
];

export default socials;
